import * as React from 'react';
import { Link } from 'react-router-dom';
import { ErrorMessage, Field, Form, Formik } from 'formik';
import * as Yup from 'yup';

const ChangePasswordSchema = Yup.object().shape({
  password: Yup.string()
    .required('Required')
    .test(
      'password',
      'Password must be at least 8 characters and include an uppercase letter, a lowercase letter, and a number.',
      value => {
        const passwordRegExp = new RegExp(/^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.{8,})/);
        return value && passwordRegExp.test(value);
      }
    ),
  confirmPassword: Yup.string().test('confirmPassword', 'Passwords must match', function(value) {
    return value === this.parent.password;
  }),
});

interface Props {
  onSubmit: (data: { password: string; confirmPassword: string }) => void;
  redirectToLoginPage: () => void;
}

export function SchoolAppChangePasswordForm2(props: Props) {
  const { onSubmit } = props;

  const changePasswordForm = {
    password: '',
    confirmPassword: '',
  };

  return (
    <div className="container">
      <div className="row">
        <div className="col-md-12">
          <div className="bFormSignIn">
            <div className="eFormSignIn">
              <Formik initialValues={changePasswordForm} validationSchema={ChangePasswordSchema} onSubmit={onSubmit}>
                {({ handleSubmit, isSubmitting }) => (
                  <Form onSubmit={handleSubmit}>
                    <div className="eFormSignInImg">
                      <img src="/dist/images/logo.png" alt="Logo" />
                    </div>

                    <h1 className="h3 mb-3 mt-3 font-weight-normal">Set a new password</h1>

                    <div className="form-group">
                      <Field
                        type="password"
                        name="password"
                        id="new_password"
                        className="form-control"
                        placeholder="New password"
                        autoComplete="new-password"
                      />
                      <ErrorMessage component="div" className="alert alert-danger mt-2" name="password" />
                    </div>

                    <div className="form-group mt-2">
                      <Field
                        type="password"
                        name="confirmPassword"
                        id="confirm_password"
                        className="form-control"
                        placeholder="Confirm password"
                        autoComplete="new-password"
                      />
                      <ErrorMessage component="div" className="alert alert-danger mt-2" name="confirmPassword" />
                    </div>

                    <button
                      className="btn btn-lg btn-primary btn-block mt-3"
                      type="submit"
                      disabled={isSubmitting}
                      id="change_password_submit"
                    >
                      Save
                    </button>

                    <div className="eFormSignInResetPassword mt-2">
                      <Link className="nav-link" to={{ pathname: '/login' }}>
                        Back to sign in
                      </Link>
                    </div>
                  </Form>
                )}
              </Formik>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
